module.exports = __webpack_public_path__ + "static/media/user-error.820b7057.svg";